import { installConsoleLogCapture } from './consoleLogBuffer';

// Side-effect module: importing it installs the console capture. It must be
// the first import of the entry file -- ES modules evaluate imports before the
// importer's body, so a plain function call in the entry file would run after
// the entire App module graph (missing anything logged during evaluation).
installConsoleLogCapture();
